<template>
<div class=" " :class="{'swiperObj':$store.state.innerWidth>=815}">
    <div class="swiperContent" ref="content">
        <swiper class="swiperCarrousel"  :options="swiperOption" v-if="showSwiper" :class="{'padding-30':showBtn}">
            <swiper-slide class="swiper-slide box-slide" v-show="listType==2" :class="{'swiper-no-swiping':!canSwiper}" v-for="(jobFunction,index) in jobFunctions">
                 <div class="boxShadow boxShadowJia pointer" ref="swiper" @click="goJobDetail(jobFunction)">
                    <h5 class="SemiBold jobTitle jobTitleJia wrap fourline-box">{{$store.getters.getContent(jobFunction.title)}} </h5>
                    <div class="item-table pad-7" v-if="$store.getters.getContent(jobFunction.organization)&&false">
                        <div class="tdcell iconWidth">
                            <i class="icon-hourse"></i>
                        </div>
                        <div class="tdcell ">
                            <p class="twoline-box" v-html="$store.getters.getContent(jobFunction.organization)"></p>
                        </div>
                    </div>
                    <div class="item-table"  v-if="$store.getters.getContent(jobFunction.department)">
                      <div class="tdcell iconWidth">
                        <i class="icon-user"></i>
                      </div>
                      <div class="tdcell wrap">
                        <p class="twoline-box"  v-html="$store.getters.getContent(jobFunction.department)"></p>
                      </div>
                    </div>
                    <p class="gray dateTime"  v-if="jobFunction.advertisingDay!=null">{{formatDay(jobFunction.advertisingDay)}}</p>
                </div>
            </swiper-slide>
        </swiper>
        <div class="swiper-button-prev" v-if="showBtn" slot="button-prev">
            <i class="icon-arrow-down"></i>
        </div>
        <div class="swiper-button-next" v-if="showBtn" slot="button-next">
            <i class="icon-arrow-down"></i>
        </div>
    </div>
</div>
</template>
<script>

export default {
    data() {
        return {
            totalRows: 0,
            jobFunctions: [],
            canSwiper:true,
            showSwiper:false,
            showBtn:false,
            getJobId:null,
            swiperOption: {
                slidesPerView: 2.2,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },
        }
    },
    computed:{
        innerwidth(){
          return this.$store.state.innerWidth;
        },
        language(){
          return  this.$store.state.language
        }
    },
    props: {
        jobid:0,
        callback:null,
        occupationIds: 0,
        listType: 0,
        jobList:null, //--1  occupationDetails.
        jobfilterobj:null,
        jobFunctionIds:null,
        hidejob:null,
        width:0,
    },
    methods: {
        goJobDetail: function(job) {
            if(this.$store.state.innerWidth>768){
                this.$store.state.formData.occupationId = this.occupationIds;
                this.$store.state.formData.jobId = job.id;
                this.$store.state.formData.relatedJobType=2;
                this.$router.push({ path: '/RelatedVacancies',query:{lang:this.$store.state.language} });
                window.scrollTo(0, 0);
            }else{
                this.$router.push({ path: "/jobDetail/" + encodeURIComponent(job.id),query:{lang:this.$store.state.language,name:this.$store.getters.replaceEvent(this.$store.getters.getContent(job.title))} });
                window.scrollTo(0, 0);
            }
            if(this.callback)
                this.callback();
        },
        init:function(){
      let Base64 = require('js-base64').Base64
            let that = this;
            switch (that.listType) {
                case 1:
                    // that.jobFunctions = that.jobList;
                    break
                case 2:
                if(this.jobid==0){return;}
                    let obj = {
                        "startRow": 0,
                        "maxRows": 5,
                        "jobId":this.jobid,
                        "keyword":Base64.encode(this.jobfilterobj.keyword),
                        "jobFunctionIds":this.jobfilterobj.jobFunctionIds,
                        "level":this.jobfilterobj.level,
                        "type":this.jobfilterobj.type,
                        "jobSourceId":this.jobfilterobj.jobSourceId,
                        "jobType":this.jobfilterobj.jobType,
                      }
                    that.api.getSimilarJobList(obj, function(data) {
                        that.totalRows = data.totalRows;
                         that.jobFunctions = [];
                        for (var i = 0; i < data.result.length; i++) {
                            let canPush = true;
                            if(that.jobid==data.result[i].id){
                                canPush = false;
                            }
                            if(that.jobFunctions.length<5&&canPush){
                                that.jobFunctions.push(data.result[i]);
                            }
                        }
                        if(that.hidejob&&that.jobFunctions.length==0){
                            that.hidejob();
                        }
                        
                        that.$set(that,'jobFunctions',that.jobFunctions);
                        that.initSwiper()
                    })
                    break
            }
        },
        formatDay:function(no){
          let num = "";
          if(no>=30){
            num = Math.floor(no/30) + this.$i18n.t("message.monthsAgo");
          }else if(no>=7){
            num = Math.floor(no/7) + this.$i18n.t("message.weeksAgo");
          }else if(no==0){
            num = this.$i18n.t("message.today");
          }else{
            num = no + this.$i18n.t("message.daysAgo");
          }
          return num;
        },
        setWidth:function(width){
            var that = this;
            this.$refs.content.style.width= '100%'
            if(width>=1345){
                this.showBtn = false;
                this.canSwiper = false;
                // this.$refs.content.style.width= '100%'
            }else if(width >= 1080){
                this.showBtn = true;
                this.canSwiper = false;
                // this.$refs.content.style.width= 1118 + 'px'
            }else if(width >= 815){
                this.showBtn = true;
                this.canSwiper = false;
                // this.$refs.content.style.width= 855 + 'px'
            }else{
                this.showBtn = false;
                this.canSwiper = true;
                this.$refs.content.style.width= '100%'
            }
            if(width>=1345){
                this.swiperOption = {
                    slidesPerView: 5,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(width >= 1080){
                var space = (width - 85 -(250)*4)/3;
                this.swiperOption = {
                    slidesPerView: 4,
                    spaceBetween: space,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(width >= 815){
                var space = (width - 85 -(250)*3)/2;
                this.swiperOption = {
                    slidesPerView: 3,
                    spaceBetween: space,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(width>768){
                this.swiperOption = {
                    slidesPerView: 3,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(width>650){
                this.swiperOption = {
                    slidesPerView: 2.9,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else if(width>550){
                this.swiperOption = {
                    slidesPerView: 2.5,
                    spaceBetween: 15,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }else{
                this.swiperOption = {
                    slidesPerView: 2.2,
                    spaceBetween: 0,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }
                }
            }
            var that = this;
                this.showSwiper = false;
                this.$nextTick(() => {
                    this.showSwiper = true
                    setTimeout(function(){
                        that.setHeightEvent();
                    })
                });
        },
        setHeightEvent:function(){
            var height = 0;
            if(this.$refs.swiper){
                for(var i=0;i<this.$refs.swiper.length;i++){
                    if(this.$refs.swiper[i].offsetHeight>height){
                        height = this.$refs.swiper[i].offsetHeight
                    }
                }
                for(var i=0;i<this.$refs.swiper.length;i++){
                    this.$refs.swiper[i].style.height = height+'px';
                }
            }
        },
        watchEvent:function(){
            if(this.jobid&&this.jobid!=this.$store.state.formData.getJobId){
                this.$store.state.formData.getJobId = this.jobid;
                this.init();
            }
        }
    },
    mounted() {
        var that = this;
        var mySwiper;
        this.initSwiper = function() {
        }
        this.init();
        var width = this.width?this.width:this.$store.state.innerWidth
        this.setWidth(width)
    },
    watch: {
        jobid() {
            if(this.jobid){
                this.init();
            }
        },
        innerwidth (news,old) {
            this.showSwiper = false;
        var width = this.width?this.width:this.$store.state.innerWidth
        this.setWidth(width)
        },
        language:function(n,o){
        var width = this.width?this.width:this.$store.state.innerWidth
        this.setWidth(width)
        }
    }
}
</script>